<!-- añadir siempre este div para englobar form -->
<div class="form-container__ampliada form-container">
  <mat-horizontal-stepper
    [linear]="isLinear"
    #stepper
    [@.disabled]="true"
    class="stepsForm"
    *ngIf="!flag"
  >
    <mat-step [stepControl]="datosCliente">
      <form [formGroup]="datosCliente" class="form__ampliada">
        <h1>Alta Cliente Xtensa Contratas</h1>
        <div>
          <h2>Datos Propios</h2>
          <div class="datos__propios">
            <mat-form-field appearance="outline">
              <mat-label>Nombre Comercial</mat-label>
              <input
                matInput
                placeholder="Nombre Comercial"
                formControlName="nombreComercial"
                required
              />
              <mat-error>Campo Obligatorio</mat-error>
            </mat-form-field>
         
            <mat-form-field appearance="outline" class="cif">
              <mat-label>CIF</mat-label>
              <input
                matInput
                type="text"
                formControlName="cif"
                id="cif"
                required
                (change)="checkCliente($event)"
              />
              <mat-error>Campo Obligatorio, por favor introduzca un número de CIF válido</mat-error>
              
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Motivo del Alta</mat-label>
              <mat-select
                placeholder="Motivo del alta"
                formControlName="motivo"
                multiple
              >
                <div *ngFor="let motivo of motivosAlta">
                  <mat-option value="{{ motivo }}">
                    {{ motivo }}
                  </mat-option>
                </div>
              </mat-select>
            </mat-form-field>
          </div>

          <h2>Información de Contacto</h2>

          <div class="datos__contacto">
            <mat-form-field appearance="outline">
              <mat-label>Nombre y apellido de Contacto</mat-label>
              <input
                matInput
                placeholder="Nombre y apellido Contacto"
                formControlName="nombre"
                required
              />
              <mat-error>Campo Obligatorio</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Mail de Contacto</mat-label>
              <input
                matInput
                placeholder="mail"
                formControlName="mail"
                required
                (keyup)="checkUser($event)"
              />
              <mat-error>Campo Obligatorio, introduzca un mail válido</mat-error>
            </mat-form-field>
          </div>
          <mat-form-field appearance="outline" class="datos__colaboradoras">
            <mat-label>Número de Contratistas a invitar</mat-label>
            <input
              matInput
              type="number"
              placeholder="Número de contratistas a invitar"
              formControlName="empresasInvitadas"
              required min="1" max="15"
            />
            <mat-error *ngIf="datosCliente.value.empresasInvitadas == 0 || datosCliente.value.empresasInvitadas == '' ">Campo Obligatorio, por favor introduzca el número Contratistas a invitar</mat-error>
            <mat-error *ngIf="datosCliente.value.empresasInvitadas > 15">Si el número de Contratistas es mayor a 15 póngase en contacto con nosotros</mat-error>      
            <mat-hint>Si el número de Contratistas es mayor a 15, puede ponerse en contacto con nosotros
              para realizar una carga masiva de datos
            </mat-hint>
          </mat-form-field>

          <div class="radio__residuos">
            <label>¿Produce Residuos Peligrosos?</label>
            <div class="radioButton">
              <div>
                <input
                  type="radio"
                  formControlName="residuosPeligrosos"
                  [value]="true"
                  id="si"
                />
                <label for="si">Sí</label>
              </div>
              <div>
                <input
                  type="radio"
                  formControlName="residuosPeligrosos"
                  value="false"
                  id="no"
                />
                <label for="no">No</label>
              </div>
            </div>
          </div>

          <div class="boton__siguiente">
            <button
              mat-button
              matStepperNext
              (click)="setInvitaciones()"
              [disabled]="datosCliente.invalid"
            >
              Siguiente
            </button>
          </div>
          <div *ngIf="datosCliente.invalid" class="campoObligatorio">
            Recuerde <strong>completar los campos obligatorios*</strong> antes de continuar
          </div>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="datosContacto">
      <form [formGroup]="datosContacto" class="form__ampliada">
        <h1>
          Datos de Contacto de sus
          {{ datosCliente.value.empresasInvitadas }} Contratistas
        </h1>
        <div>
          <h2>Datos de sus Contratistas</h2>
        </div>

        <div
          formArrayName="contactoMail"
          *ngFor="let invitacion of contactoMail.controls; let i = index"
        >
          <div [formGroupName]="i">
            <div class="datos__contratista">
              <mat-form-field appearance="outline">
                <mat-label>Mail de Empresa Contratista</mat-label>
                <input
                  matInput
                  placeholder="Mail de contratista"
                  formControlName="mail"
                  id="{{ 'mail' + i }}"
                  required
                />
                <mat-error>Campo Obligatorio, introduzca un mail válido</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>CIF de la Empresa Contratista</mat-label>
                <input
                  matInput
                  placeholder="CIF de contratista"
                  formControlName="cif"
                  id="{{'cif'+i}}"
                  required
                />
                <mat-error>Campo Obligatorio, por favor introduzca un número de CIF válido</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="boton__pasos">
          <button mat-button matStepperPrevious (click)="resetEmpresasInvitadas()">Anterior</button>
          <button mat-button matStepperNext [disabled]="datosContacto.invalid">
            Siguiente
          </button>
        </div>
      </form>
    </mat-step>
    <mat-step [stepControl]="importe">
      <form [formGroup]="importe">
        <h1>
          Datos de Contacto de sus
          {{ datosCliente.value.empresasInvitadas }} Contratistas
        </h1>
        <div>
          <p class="totalResults">
            El importe anual de la licencia para sus Contratistas es
            <span class="totalResults__number">XXXX</span> (IVA incluido)
          </p>
        </div>
        <div class="privacidad">
          <input type="checkbox" id="privacidad" formControlName="policy"/>
         <label for="privacidad" id="privacidad"> He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a></label><br><br>
         <input type="checkbox" id="newsletter" (change)="setNewsletter($event)"/>
         <label for="newsletter" id="newsletter" > Acepto recibir la información comercial que INPRONET SOLUTIONS SL considere oportuno enviarme por correo electrónico.<br> (Es posible darse de baja en cualquier momento)</label><br><br>
         <p id="proteccion">
          El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL.<br> La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros.<br> Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
        </div>
        <div class="boton__pasos">
          <button mat-button matStepperPrevious>Anterior</button>
          <button
            mat-button
            matStepperNext
            [disabled]="datosContacto.invalid || importe.invalid"
            (click)="save($event)"
          >
            Hecho
          </button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
  <div
    *ngIf="flag"
    class="stepsForm"
  >
      <h1 class="registro">¡Muchas Gracias!</h1>
        <h1 class="registro">Hemos enviado la invitación a sus Contratistas</h1>
      <h3 class="registro-mail"> En breve recibirá un mail de verificación de cuenta en su bandeja de entrada.</h3>
      <button class="registro-boton" [routerLink]="['']">Cerrar</button>
  </div>
</div>
<!-- <button type="submit" (click)="addGestor()" [mat-dialog-close] [disabled]="datosGestor.invalid">Hecho</button>
            </div> -->
